import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const FeedbackProcessModule = {
  namespaced: true,
  state: {
    view: 'feedbackForm',
    solicitorId: ''
  },
  actions: {
    async sendAnswers ({ commit, state, rootGetters }, { questions, answers, successStepName }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation tnpsFeedback ($answers: [AnswerInput!]!, $brand: String!, $solicitorId: String! ){
          sendFeedbackAnswers(feedbackAnswerRequest: {
            answerList: $answers,
            brand: $brand,
            solicitorId: $solicitorId
          }) {
            success
          }
        }`,
        variables: {
          answers: questions.map(question => {
            return {
              question: question.questionText,
              answer: answers[question.id] || (question.answerType === 'numberRange' ? 0 : '')
            }
          }),
          brand: rootGetters.brand,
          solicitorId: state.solicitorId
        }
      }).then((response) => {
        if (response.data.sendFeedbackAnswers.success === true) {
          commit('Transaction/removeTransactionId', 'tnpsFeedback', { root: true })
          commit('changeStep', successStepName)
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    changeStep (state, newView) {
      state.view = newView
    },
    setSolicitorId (state, solicitorId) {
      state.solicitorId = solicitorId
    }
  },
  getters: {
    getStep: state => {
      return state.view
    },
    solicitorId: state => {
      return state.solicitorId
    }
  }
}

export {
  FeedbackProcessModule
}
